import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { ApiPasswordReset, ApiPasswordValidate, ServerResponse } from '../../api';
import ErrorBox from '../../components/errorBox/ErrorBox';
import ErrorMessage from '../../components/errorMessage/ErrorMessage';
import Footer from '../../components/footer/Footer';
import HeaderLoggedOut from '../../components/headerLoggedOut/HeaderLoggedOut';
import './NewPassword.css';

interface ForgotPasswordProps {
    match: { params: { token: string } };
}

interface ForgotPasswordState {
    serverResponse: ServerResponse | undefined;
    serverResponseValidate: ServerResponse | undefined;
    password: string;
    passwordRepeat: string;
    errors: string[];
}

export default class NewPassword extends React.PureComponent<ForgotPasswordProps, ForgotPasswordState> {
    constructor(props: any) {
        super(props);
        this.state = {
            errors: [],
            password: '',
            passwordRepeat: '',
            serverResponse: undefined,
            serverResponseValidate: undefined,
        };
    }

    public componentDidMount() {
        ApiPasswordValidate({ Token: this.props.match.params.token }, (sr: ServerResponse) => {
            this.setState({ serverResponseValidate: sr });
        });
    }

    public render() {
        if (this.state.serverResponseValidate && !this.state.serverResponseValidate.OK) {
            return <Redirect to="/newPasswordFailed" />;
        }
        if (this.state.serverResponse && this.state.serverResponse.OK) {
            return <Redirect to="/newPasswordSuccess" />;
        }

        return (
            <>
                <HeaderLoggedOut />
                <Container id="newPasswordView" className="text-center">
                    <Row>
                        <Col>
                            <h3>{TR.newPassword_new_password}</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="offset-md-3">
                            {TR.newPassword_choose_new}
                            <br />
                            <Form className="mt-4">
                                <ErrorBox serverResponse={this.state.serverResponse} />
                                <ErrorMessage errors={this.state.errors} />
                                <FormGroup>
                                    <Label>{TR.newPassword_password}</Label>
                                    <Input type="password" id="password" onChange={this.inputHandler} />
                                </FormGroup>
                                <FormGroup>
                                    <Label>{TR.newPassword_again}</Label>
                                    <Input type="password" id="passwordRepeat" onChange={this.inputHandler} />
                                </FormGroup>

                                <Button className="mt-3" onClick={this.passwordReset}>
                                    {TR.newPassword_save}
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </>
        );
    }

    private inputHandler = (e: any) => {
        this.setState({ serverResponse: undefined });
        const newstate = {};
        newstate[e.target.id] = e.target.value;
        this.setState(newstate);
    };

    private passwordReset = () => {
        if (this.state.password !== this.state.passwordRepeat) {
            this.setState({ errors: [TR.newPassword_not_same] });
            return;
        }

        this.setState({ errors: [] }, () => {
            ApiPasswordReset(
                { Token: this.props.match.params.token, Password: this.state.password },
                (sr: ServerResponse) => {
                    this.setState({ serverResponse: sr });
                }
            );
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/newPassword/NewPassword.tsx